// The AI service switched off for confidential documents, worded for who reads it: an Admin is told to switch it on in Settings and gets a link straight to the AI service settings (/admin/settings#ai), everyone else that an administrator must switch it on; shown before a refused request where the meta flag says it is off, and with the refusal itself.
import { Link } from "@tanstack/react-router";
import { InfoIcon, SettingsIcon } from "lucide-react";

import type { ProblemCopy } from "@/api/problem";
import { useCanAccess } from "@/app/session";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";

import { AI_SERVICE_OFF, AI_SERVICE_OFF_FOR_ADMINS } from "./problems";

export function useAiServiceOffCopy(): ProblemCopy {
  return useCanAccess("A") ? AI_SERVICE_OFF_FOR_ADMINS : AI_SERVICE_OFF;
}

export function AiServiceSettingsLink({ className }: { className?: string }) {
  if (!useCanAccess("A")) {
    return null;
  }
  return (
    <Button asChild variant="outline" size="sm" className={cn("w-fit", className)}>
      <Link to="/admin/settings" hash="ai">
        <SettingsIcon aria-hidden />
        Open AI service settings
      </Link>
    </Button>
  );
}

export function AiServiceOffAlert({ className }: { className?: string }) {
  const copy = useAiServiceOffCopy();
  return (
    <Alert variant="neutral" className={className}>
      <InfoIcon aria-hidden />
      <AlertTitle>{copy.title}</AlertTitle>
      <AlertDescription>
        <p>{copy.description}</p>
        <AiServiceSettingsLink className="mt-2" />
      </AlertDescription>
    </Alert>
  );
}
